import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { computed, Injectable, Signal } from '@angular/core';
import { globalStore } from '../../../../shared/shared.global-service';
import { toSignal } from '@angular/core/rxjs-interop';
import { FolderDataShareObject } from '@libs/types/src/services/object-type/folder/folder-data-share.object';
import { selectRouteParam } from '../../../../../store/global/router.selector';
import { map } from 'rxjs/operators';

@Injectable()
export class ServiceDataShareStore extends ComponentStoreV2Factory {

    serviceId: Signal<number | undefined> = toSignal(
        globalStore.select(selectRouteParam('serviceId')).pipe(map(param => param ? Number(param) : undefined)),
    );
    items = computed<FolderDataShareObject[]>(() => this.data.getServiceDataShares()?.items || []);
    sourceService = computed(() => this.globalGlobalStore.organizationStore.allServices()
        .find((service) => service.id === this.serviceId()));

    availableServices = computed(
        () => this.globalGlobalStore.organizationStore.allServices()
            ?.filter((it) => it.id !== this.serviceId()) || [],
    );

}
